module.exports = __webpack_public_path__ + "static/media/no-todos.ac904ea0.svg";